export default __webpack_public_path__ + "static/media/brave_lion.a6cda691.svg";